



























/* General */
import Vue from 'vue'
import logoSrc from '@/assets/img/logos/logo-donedone.svg'

/* Mixins */

/* Components */

/* Helpers */
import RouteAssistant from '@/helpers/route-assistant'

/* Data types */
import { IPersonWithEmail } from '@/api/types/response.types'

/* API */
import TicketPortalAPI from '@/api/modules/ticket-portal.api'
import { ITicketPortalInputUpdateProfile } from '@/api/types/request.types'

export default Vue.extend({
  name: 'TicketPortalHeader',

  components: {},
  props: {
    ticketPortalName: {
      type: String,
      default: '',
    },
    logoUrl: {
      type: String,
      default: null,
    },
    customer: {
      type: Object as () => IPersonWithEmail,
      required: true,
    },
    hideHomeOnMobile: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      RouteAssistant,
      logo: {
        src: logoSrc,
        alt: 'Logo DoneDone',
      },
      showEditProfile: false,
      formData: {} as ITicketPortalInputUpdateProfile,
    }
  },

  computed: {
    hasLogoUrl(): Boolean {
      return this.logoUrl !== null && this.logoUrl.length > 0
    },
  },

  methods: {
    async signOut() {
      try {
        const response = await TicketPortalAPI.get_LogoutWithRedirectLink(
          this.$route.params.mailboxId,
        )
        RouteAssistant.goToUrl(response.redirectLink)
      } catch (error) {
        this.$error.emit(error)
      }
    },
  },
})
